import { ReactComponent as NomIcon } from "./nom.svg";

import Icon from "../Icon";

export default NomIcon as any as Icon;
